export default {
  // sync actions
  ACTION_SET: 'SET',
  ACTION_REMOVE: 'REMOVE',
  OPEN_ONE_NOTIFICATION: 'OPEN_ONE_NOTIFICATION',
  OPEN_MANY_NOTIFICATIONS: 'OPEN_MANY_NOTIFICATIONS',
  CLOSE_NOTIFICATION: 'CLOSE_NOTIFICATION',
  SHOW_LOADER: 'SHOW_LOADER',
  HIDE_LOADER: 'HIDE_LOADER',

  // async actions
  ACTION_CREATE: 'CREATE',
  ACTION_GET: 'GET',
  ACTION_DELETE: 'DELETE',
  ACTION_UPDATE: 'UPDATE'
};
